import { render, staticRenderFns } from "./ViewJobDetails.vue?vue&type=template&id=27eebb9c&scoped=true"
import script from "./ViewJobDetails.vue?vue&type=script&lang=ts"
export * from "./ViewJobDetails.vue?vue&type=script&lang=ts"
import style0 from "./ViewJobDetails.vue?vue&type=style&index=0&id=27eebb9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eebb9c",
  null
  
)

export default component.exports